<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="1000px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Asmenų tikrinimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-data-table
              :headers="filteredHeaders"
              :items="itemsList"
              :loading="tableLoading"
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageText: 'Rodyti po:',
                itemsPerPageAllText: 'visi',
                itemsPerPageOptions: itemsPerPageOptions,
              }"
              :hide-default-footer="hideFooter"
              :items-per-page="pageSize"
            >
              <template #top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label=""
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template #[`header.taar`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckTaar"
                  @click.native.stop="checkAllTaar()"
                />
              </template>
              <template #[`header.nirvar`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckNirvar"
                  @click.native.stop="checkAllNirvar()"
                />
              </template>
              <template #[`header.vsr`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckVsr"
                  @click.native.stop="checkAllVsr()"
                />
              </template>
              <template #[`item.taar`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isTaar"
                    label=" "
                    v-model="checkTaar"
                    :checkValue="item.sasm_id"
                    :key="`taar${item.sasm_id}`"
                  />
                </div>
              </template>
              <template #[`item.nirvar`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isNirvar"
                    label=" "
                    v-model="checkNirvar"
                    :checkValue="item.sasm_id"
                    :key="`nirvar${item.sasm_id}`"
                  />
                </div>
              </template>
              <template #[`item.vsr`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isVsr"
                    label=" "
                    v-model="checkVsr"
                    :checkValue="item.sasm_id"
                    :key="`vsr${item.sasm_id}`"
                  />
                </div>
              </template>
              <template #[`body.append`]>
                <tr>
                  <td colspan="7" class="text-end">
                    <strong>Kaina iš viso:</strong>
                  </td>
                  <td class="text-center">{{ visoVerte }}</td>
                </tr>
              </template>
              <template slot="loading">
                Kraunasi...
              </template>
              <template slot="no-results">
                Duomenų nėra
              </template>
              <template slot="no-data">
                Duomenų nėra
              </template>
              <template #[`footer.page-text`]="props">
                Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button
          primary
          :disabled="!enableSubmit"
          @click.native.stop="openConfirm()"
        >
          Tikrinti
        </el-button>
      </v-card-actions>
    </v-card>

    <modal-confirm
      title="Asmenų tikrinimas"
      text="Ar tikrai norite atlikti tikrinimą?"
      action="AsmuoCheck"
      v-model="showConfirm"
      @confirmAsmuoCheck="saveData"
      @cancelConfirm="cancelData"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import ModalConfirm from './ModalConfirm'

export default {
  name: 'ModalAsmuoCheck',
  props: {
    value: Boolean,
  },
  components: {
    ModalConfirm,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tableLoading: false,
      asmenys: [],
      checkTaar: [],
      checkNirvar: [],
      checkVsr: [],
      headerCheckTaar: false,
      headerCheckNirvar: false,
      headerCheckVsr: false,
      showConfirm: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: 'Asmens kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
        },
        {
          text: 'Vardas Pavardė',
          align: 'start',
          value: 'fullname',
        },
        {
          text: 'TAAR',
          align: 'start',
          sortable: false,
          value: 'taar',
        },
        {
          text: 'Kaina',
          align: 'start',
          sortable: false,
          value: 'kainaTaar',
        },
        {
          text: 'NIRVAR',
          align: 'start',
          sortable: false,
          value: 'nirvar',
        },
        {
          text: 'Kaina',
          align: 'start',
          sortable: false,
          value: 'kainaNirvar',
        },
        {
          text: 'VSR',
          align: 'start',
          sortable: false,
          value: 'vsr',
        },
        {
          text: 'Kaina',
          align: 'start',
          sortable: false,
          value: 'kainaVsr',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        item.isTaar = item.kaina_taar > 0
        item.isNirvar = item.kaina_nirvar > 0
        item.isVsr = item.kaina_vsr > 0

        item.kainaTaar = item.isTaar ? this.moneyformat(item.kaina_taar) : ''
        item.kainaNirvar = item.isNirvar
          ? this.moneyformat(item.kaina_nirvar)
          : ''
        item.kainaVsr = item.isVsr ? this.moneyformat(item.kaina_vsr) : ''
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    visoVerte() {
      let visoTaar = this.itemsList
        .map(item =>
          item.kaina_taar > 0 && this.checkTaar.includes(item.sasm_id)
            ? item.kaina_taar
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
      let visoNirvar = this.itemsList
        .map(item =>
          item.kaina_nirvar > 0 && this.checkNirvar.includes(item.sasm_id)
            ? item.kaina_nirvar
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
      let visoVsr = this.itemsList
        .map(item =>
          item.kaina_vsr > 0 && this.checkVsr.includes(item.sasm_id)
            ? item.kaina_vsr
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)

      return this.moneyformat(visoTaar + visoNirvar + visoVsr)
    },
    enableSubmit() {
      return (
        this.checkTaar.length > 0 ||
        this.checkNirvar.length > 0 ||
        this.checkVsr.length > 0
      )
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.tableLoading = true
      this.$axios
        .get(`objektas/${this.objektasID}/tikrinimas-asmuo`)
        .then(res => {
          this.asmenys = res.data.asmenys
          this.headerCheckTaar = false
          this.headerCheckNirvar = false
          this.headerCheckVsr = false
          this.checkTaar = []
          this.checkNirvar = []
          this.checkVsr = []
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.tableLoading = false
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.loading = true
      const data = {
        asmenys: this.getRegistrasData(),
      }

      this.$axios
        .post(`objektas/${this.objektasID}/tikrinimas-asmuo`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$emit('savedData')
          this.closeModal()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRegistrasData() {
      return this.itemsList.map(item => {
        return {
          sasm_id: item.sasm_id,
          taar: this.checkTaar.includes(item.sasm_id),
          nirvar: this.checkNirvar.includes(item.sasm_id),
          vsr: this.checkVsr.includes(item.sasm_id),
        }
      })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    modalshow() {
      //
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    openConfirm() {
      this.showConfirm = true
    },
    checkAllTaar() {
      this.checkTaar = []
      if (this.headerCheckTaar) {
        this.itemsList.forEach(item => {
          if (item.isTaar) {
            this.checkTaar.push(item.sasm_id)
          }
        })
      }
    },
    checkAllNirvar() {
      this.checkNirvar = []
      if (this.headerCheckNirvar) {
        this.itemsList.forEach(item => {
          if (item.isNirvar) {
            this.checkNirvar.push(item.sasm_id)
          }
        })
      }
    },
    checkAllVsr() {
      this.checkVsr = []
      if (this.headerCheckVsr) {
        this.itemsList.forEach(item => {
          if (item.isVsr) {
            this.checkVsr.push(item.sasm_id)
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
